import { FC, ReactNode } from 'react'

type IProps = {
    children: ReactNode,
    className?: string,
    variant?: 'outlined' | 'contained' | 'none'
    size?: 'large' | 'small',
    onClick?: () => void;
}

const ButtonComponent: FC<IProps> = ({ children, className = '', variant = 'contained', size = 'small', onClick, ...otherProps }) => {
    const sizeClasses = {
        'small': 'btn-common h-[40px] px-[30px]',
        'large': 'btn-common md:h-[51px] md:px-[36px] px-[30px] h-[39.39px] font-bold text-[16px] md:text-[18px]'
    }
    const variantClasses = {
        'outlined': "border-[#1a1a1a] bg-white text-[#1a1a1a]",
        'contained': "bg-[#1A1A1A] text-[#ffffff]",
        'none': 'bg-white text-[#1a1a1a] border-gray-100 shadow-md'
    }
    return (
        <button onClick={() => {
            if (onClick) {
                onClick()
            }
        }} className={`font-semibold rounded-3xl border-2 border-primary min-w-max flex gap-2 items-center px-6 text-bodySmall md:text-body justify-center ${sizeClasses[size]} ${variantClasses[variant]} ${className}`} {...otherProps}>{children}</button>
    )
}

export default ButtonComponent